<template>
  <div class="content d-flex flex-column flex-column-fluid mb-10" id="kt_content">
    <div class="post d-flex flex-column-fluid" id="kt_post">
      <div class="container-xxl text-center py-10">
        <span v-if="loading" class="spinner-border spinner-border-sm text-primary"></span>
        <div v-else class="d-flex flex-column align-items-center">
          <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-100px mb-5"/>
          <div class="text-gray-800 fs-4 fw-bolder mb-2">{{ $t('report.no_reports_title') }}</div>
          <div class="text-gray-500 fs-6 mw-500px">{{ message }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // Page de redirection uniquement : le choix du rapport se fait désormais
  // via le menu latéral sur la page du rapport elle-même (plus pratique
  // qu'un premier écran intermédiaire à traverser à chaque fois). Si rien
  // n'est disponible (erreur, ou aucune catégorie de rapport activée), on
  // l'affiche au lieu de laisser le loader tourner indéfiniment.
  data() {
    return {
      loading: true,
      message: '',
    }
  },
  async mounted() {
    try {
      const response = await axios.get('report/list')
      const reports = Object.values(response.data.categories || {}).flat()
      if (reports.length) {
        this.$router.replace({ name: 'rapports-viewer-path', params: { slug: reports[0].slug } })
        return
      }
      this.message = this.$t('report.no_reports_available')
    } catch (e) {
      console.error(e)
      this.message = this.$t('report.load_error')
    }
    this.loading = false
  },
}
</script>
